/* eslint-disable no-empty-pattern */
import {call, put} from 'redux-saga/effects'
import {push} from 'connected-react-router'
import TopPerformingActions from '../Redux/TopPerformingRedux'
import AuthActions from '../Redux/AuthRedux'
import ErrorsActions from '../Redux/ErrorsRedux'

export function* getTopPerforming(api, authApi, {page, page_size, search, filter, sort, nextPage}) {
  try {
    const response = yield call(api.getTopPerforming, page, page_size, search, filter, sort, nextPage)
    if (response && response.ok) {
      yield put(TopPerformingActions.topPerformingSuccess(response.data))
    } else {
      if (response && response.data) {
        if (response.status === 401) {
          yield put(ErrorsActions.errorSave(null))
        } else if (response.status === 500) {
          yield put(ErrorsActions.errorSave('Server response error'))
        } else {
          yield put(ErrorsActions.errorSave(response.data))
        }
      } else {
        yield put(ErrorsActions.errorSave('Server response error'))
      }
      yield put(TopPerformingActions.topPerformingFetchingReset())
    }

    if (response && response.status === 401) {
      const res = yield call(authApi.tokenRefresh)
      if (res && res.access) {
        yield put(AuthActions.updateTokens(res.access, res.refresh))
        yield* getTopPerforming(api, authApi, {page, page_size, search, filter, sort, nextPage})
      } else {
        yield put(AuthActions.logout())
        yield put(push('/login'))
      }
    }
  } catch (e) {
    yield put(TopPerformingActions.topPerformingFetchingReset())
    yield put(ErrorsActions.errorSave('Server response error: ' + e))
  }
}

export function* getTopPerformingId(api, authApi, {id}) {
  try {
    const response = yield call(api.getTopPerformingId, id)
    if (response && response.ok) {
      yield put(TopPerformingActions.topPerformingIdSuccess(response.data))
    } else {
      if (response && response.data) {
        if (response.status === 401) {
          yield put(ErrorsActions.errorSave(null))
        } else if (response.status === 500) {
          yield put(ErrorsActions.errorSave('Server response error'))
        } else {
          yield put(ErrorsActions.errorSave(response.data))
        }
      } else {
        yield put(ErrorsActions.errorSave('Server response error'))
      }
      yield put(TopPerformingActions.topPerformingFetchingReset())
    }

    if (response && response.status === 401) {
      const res = yield call(authApi.tokenRefresh)
      if (res && res.access) {
        yield put(AuthActions.updateTokens(res.access, res.refresh))
        yield* getTopPerformingId(api, authApi, {id})
      } else {
        yield put(AuthActions.logout())
        yield put(push('/login'))
      }
    }
  } catch (e) {
    yield put(TopPerformingActions.topPerformingFetchingReset())
    yield put(ErrorsActions.errorSave('Server response error: ' + e))
  }
}

export function* followAuthorTpp(api, authApi, {authorId}) {
  try {
    const response = yield call(api.followAuthorTpp, authorId)
    if (response && response.ok) {
      yield put(TopPerformingActions.followAuthorTppSuccess(authorId, response.data.followed))
    } else {
      if (response && response.data) {
        if (response.status === 401) {
          yield put(ErrorsActions.errorSave(null))
        } else if (response.status === 500) {
          yield put(ErrorsActions.errorSave('Server response error'))
        } else {
          yield put(ErrorsActions.errorSave(response.data))
        }
      } else {
        yield put(ErrorsActions.errorSave('Server response error'))
      }
      yield put(TopPerformingActions.topPerformingFetchingReset())
    }

    if (response && response.status === 401) {
      const res = yield call(authApi.tokenRefresh)
      if (res && res.access) {
        yield put(AuthActions.updateTokens(res.access, res.refresh))
        yield* followAuthorTpp(api, authApi, {authorId})
      } else {
        yield put(AuthActions.logout())
        yield put(push('/login'))
      }
    }
  } catch (e) {
    yield put(TopPerformingActions.topPerformingFetchingReset())
    yield put(ErrorsActions.errorSave('Server response error: ' + e))
  }
}

export function* saveTopPerforming(api, authApi, {publicationId, folderId}) {
  try {
    const response = yield call(api.saveTopPerforming, publicationId, folderId)
    if (response && response.ok) {
      yield put(TopPerformingActions.saveTopPerformingSuccess(publicationId, response.data.saved))
    } else {
      if (response && response.data) {
        if (response.status === 401) {
          yield put(ErrorsActions.errorSave(null))
        } else if (response.status === 500) {
          yield put(ErrorsActions.errorSave('Server response error'))
        } else {
          yield put(ErrorsActions.errorSave(response.data))
        }
      } else {
        yield put(ErrorsActions.errorSave('Server response error'))
      }
      yield put(TopPerformingActions.topPerformingFetchingReset())
    }

    if (response && response.status === 401) {
      const res = yield call(authApi.tokenRefresh)
      if (res && res.access) {
        yield put(AuthActions.updateTokens(res.access, res.refresh))
        yield* saveTopPerforming(api, authApi, {publicationId, folderId})
      } else {
        yield put(AuthActions.logout())
        yield put(push('/login'))
      }
    }
  } catch (e) {
    yield put(TopPerformingActions.topPerformingFetchingReset())
    yield put(ErrorsActions.errorSave('Server response error: ' + e))
  }
}

export function* getReportTppReasons(api, authApi, {}) {
  try {
    const response = yield call(api.getReportTppReasons)
    if (response && response.ok) {
      yield put(TopPerformingActions.reportReasonsTppSuccess(response.data))
    } else {
      if (response && response.data) {
        if (response.status === 401) {
          yield put(ErrorsActions.errorSave(null))
        } else if (response.status === 500) {
          yield put(ErrorsActions.errorSave('Server response error'))
        } else {
          yield put(ErrorsActions.errorSave(response.data))
        }
      } else {
        yield put(ErrorsActions.errorSave('Server response error'))
      }
      yield put(TopPerformingActions.reportFetchingTppReset())
    }

    if (response && response.status === 401) {
      const res = yield call(authApi.tokenRefresh)
      if (res && res.access) {
        yield put(AuthActions.updateTokens(res.access, res.refresh))
        yield* getReportTppReasons(api, authApi, {})
      } else {
        yield put(AuthActions.logout())
        yield put(push('/login'))
      }
    }
  } catch (e) {
    yield put(TopPerformingActions.reportFetchingTppReset())
    yield put(ErrorsActions.errorSave('Server response error: ' + e))
  }
}

export function* sendTppReport(api, authApi, {id, data}) {
  try {
    const response = yield call(api.sendTppReport, id, data)
    if (response && response.ok) {
      yield put(TopPerformingActions.sendReportTppSuccess(response.data))
    } else {
      if (response && response.data) {
        if (response.status === 401) {
          yield put(ErrorsActions.errorSave(null))
        } else if (response.status === 500) {
          yield put(ErrorsActions.errorSave('Server response error'))
        } else {
          yield put(ErrorsActions.errorSave(response.data))
        }
      } else {
        yield put(ErrorsActions.errorSave('Server response error'))
      }
      yield put(TopPerformingActions.reportFetchingTppReset())
    }

    if (response && response.status === 401) {
      const res = yield call(authApi.tokenRefresh)
      if (res && res.access) {
        yield put(AuthActions.updateTokens(res.access, res.refresh))
        yield* sendTppReport(api, authApi, {id, data})
      } else {
        yield put(AuthActions.logout())
        yield put(push('/login'))
      }
    }
  } catch (e) {
    yield put(TopPerformingActions.reportFetchingTppReset())
    yield put(ErrorsActions.errorSave('Server response error: ' + e))
  }
}
